export const Translations = {
  'en': {
    'scanCardsLabel': 'SCAN CARDS',
    'addButtonLabel': 'ADD/EDIT SCAN CARD',
    'saveButtonLabel': 'SAVE CHANGES',
    'cancelLabel': 'CANCEL',
    'closeLabel': 'CLOSE',
    'submitLabel': 'SUBMIT',
    'whatIsScanCardLabel': 'What is a scan card?',
    'cardNumberLabel': 'Card Number',
    'cardNumberPlaceholder': 'Add new card number',
    'cardholderNameLabel': 'Cardholder\'s Name',
    'cardholderNamePlaceholder': 'Add cardholder Name',
    'deactivateLabel': 'Deactivate',
    'scanCardDescription': 'Thank you for adding a SCS qualified product. You may add a new Scan Card or a previous Scan Card may be reactivated. Please contact your local office if you wish to reactivate an old Scan Card.',
    'scanCardsInfoHeader1': 'Take Action:',
    'scanCardsInfoText1': 'Obtain a Scan Card from a Scanner Operator when you scan for the first time.',
    'scanCardsInfoText2': 'Activate your Scan Card either by telephone or online in ADR Management.',
    'scanCardsInfoHeader2': 'The Benefits:',
    'scanCardsInfoText3': 'The Scan Card is reusable and once activated, it becomes a free monthly scan as a LIFETIME benefit - for as long as you continue your qualified Pharmanex product ADR.',
    'scanCardsInfoText4': 'There are two parts to the card - a large card (similar in size to a credit card) and a small card that you can attach to your key ring. Both of these will have the same bar coded certificate number (your scan card number) and you may use either for your personal monthly scan.',
    'scanCardsInfoText5': 'Each time you scan with your Scan Card, your individual SCS results from the BioPhotonic Scanner will be recorded so you may track your personal progress each month.',
    'noScanCardsMessage': 'No Scan Cards have been linked to this ADR.',
    'deactivationInfo': 'The Scan Card(s) marked for deactivation cannot be reactivated. If in the future you wish to resume the Scan Card program, you must purchase a new Scan Card. Please check the box to acknowledge that you have read this statement and agree to these terms of the Scan Card program.',
    'deactivationLabel': 'Please Deactivate the Scan Card Indicated.',
    'noCardholderNameErrorMessage': 'Card holder name is blank.',
    'duplicateCardNumbersErrorMessage': 'The same scan card number has been used more than once.',
    'invalidCardNumberErrorMessage': 'Scan Card number is invalid. Please re-enter.'
  },
  'es': {
    'scanCardsLabel': 'ESCANEAR TARJETAS',
    'addButtonLabel': 'AGREGAR / EDITAR TARJETA SCAN',
    'saveButtonLabel': 'GUARDAR CAMBIOS',
    'cancelLabel': 'CANCELAR',
    'closeLabel': 'CERCA',
    'submitLabel': 'ENVIAR',
    'whatIsScanCardLabel': '¿Qué es una tarjeta de escaneo?',
    'cardNumberLabel': 'Número de tarjeta',
    'cardNumberPlaceholder': 'Agregar nuevo número de tarjeta',
    'cardholderNameLabel': 'Nombre del tarjetahabiente',
    'cardholderNamePlaceholder': 'Agregar nombre del titular de la tarjeta',
    'deactivateLabel': 'Desactivar',
    'scanCardDescription': 'Gracias por agregar un producto calificado SCS. Puede agregar una nueva tarjeta Scan o una tarjeta Scan anterior puede ser reactivada. Comuníquese con su oficina local si desea reactivar una tarjeta escaneada anterior.',
    'scanCardInfo': [
      {
        'header': 'Tomar acción:',
        'data': [
          {'text': 'Obtenga una tarjeta de escaneo de un operador de escáner cuando escanee por primera vez.'},
          {'text': 'Active su Scan Card ya sea por teléfono o en línea en ADR Management.'}
        ]
      },
      {
        'header': 'Los beneficios:',
        'data': [
          {'text': 'La tarjeta Scan es reutilizable y, una vez activada, se convierte en un análisis mensual gratuito como beneficio de POR VIDA, siempre que continúe con su ADR de producto Pharmanex calificado.'},
          {'text': 'Hay dos partes en la tarjeta: una grande (similar en tamaño a una tarjeta de crédito) y una pequeña que puede adjuntar a su llavero. Ambos tendrán el mismo número de certificado con código de barras (el número de su tarjeta de escaneo) y puede usarlo para su escaneo mensual personal.'},
          {'text': 'Cada vez que escanee con su Scan Card, sus resultados individuales de SCS del Escáner BioPhotonic serán grabados para que pueda seguir su progreso personal cada mes.'}
        ]
      }
    ],
    'noScanCardsMessage': 'No se han vinculado tarjetas de escaneo a este ADR.',
    'deactivationInfo': 'Las tarjetas de escaneo marcadas para desactivación no se pueden reactivar. Si en el futuro desea reanudar el programa Scan Card, debe comprar una nueva Scan Card. Marque la casilla para confirmar que ha leído esta declaración y acepta estos términos del programa Scan Card.',
    'deactivationLabel': 'Desactive la tarjeta de escaneo indicada.',
    'noCardholderNameErrorMessage': 'El nombre del titular de la tarjeta está en blanco.',
    'duplicateCardNumbersErrorMessage': 'El mismo número de tarjeta de escaneo se ha usado más de una vez.',
    'invalidCardNumberErrorMessage': 'El número de Scan Card no es válido. Por favor, vuelva a ingresar.'
  },
  'zh': {
    'scanCardsLabel': '扫描卡',
    'addButtonLabel': '添加/编辑扫描卡',
    'saveButtonLabel': '保存更改',
    'cancelLabel': '取消',
    'closeLabel': '关',
    'submitLabel': '提交',
    'whatIsScanCardLabel': '什么是扫描卡?',
    'cardNumberLabel': '卡号',
    'cardNumberPlaceholder': '添加新的卡号',
    'cardholderNameLabel': '持卡人姓名',
    'cardholderNamePlaceholder': '添加持卡人姓名',
    'deactivateLabel': '停用',
    'scanCardDescription': '感谢您添加SCS合格产品。您可能会添加新的扫描卡或先前的扫描卡可能会重新激活。如果您想重新激活旧的扫描卡，请联系您当地的办事处。',
    'scanCardInfo': [
      {
        'header': '采取行动:',
        'data': [
          {'text': '第一次扫描时，请从扫描仪操作员处获取扫描卡。'},
          {'text': '在ADR管理中通过电话或在线激活您的扫描卡。'}
        ]
      },
      {
        'header': '好处：',
        'data': [
          {'text': '扫描卡可重复使用，一旦激活，它就成为每月免费扫描的终身优惠 - 只要您继续使用合格的Pharmanex产品ADR即可。'},
          {'text': '该卡有两部分 - 一张大卡（与信用卡大小相似）和一张小卡，您可以将其连接到钥匙圈。这两个都会有相同的条形码证书号码（您的扫描卡号码），您可以使用它来进行个人月度扫描。'},
          {'text': '每次使用扫描卡进行扫描时，生物光子扫描仪的个人SCS结果都将被记录下来，以便您可以追踪每个月的个人进度。'}
        ]
      }
    ],
    'noScanCardsMessage': '没有扫描卡已经链接到这个ADR。',
    'deactivationInfo': '标记为禁用的扫描卡不能重新激活。如果将来希望恢复扫描卡计划，则必须购买新的扫描卡。请选中复选框以确认您已阅读此声明并同意这些扫描卡计划的条款。',
    'deactivationLabel': '请关闭指示的扫描卡。',
    'noCardholderNameErrorMessage': '持卡人姓名为空。',
    'duplicateCardNumbersErrorMessage': '相同的扫描卡号码已被使用多次。',
    'invalidCardNumberErrorMessage': '扫描卡号码无效。请重新输入。'
  }
};
